<div *ngIf="formControlObj.invalid && (formControlObj.touched || disableField)" class="error-message">
  <div>{{getError(formControlObj.errors)}}</div>
</div>
